import { Route, Routes } from 'react-router-dom';

import { MagicLinkRequest, MagicLinkVerify } from '../public/MagicLink';

import { MemberDashboard } from './Dashboard';
import { MyPayments } from './MyPayments';
import { MyRegistrations } from './MyRegistrations';
import { PortalShell } from './PortalShell';
import { Preferences } from './Preferences';

export function MemberPortal() {
  return (
    <Routes>
      <Route path="login" element={<MagicLinkRequest />} />
      <Route path="verify" element={<MagicLinkVerify />} />
      <Route element={<PortalShell />}>
        <Route index element={<MemberDashboard />} />
        <Route path="registrations" element={<MyRegistrations />} />
        <Route path="payments" element={<MyPayments />} />
        <Route path="preferences" element={<Preferences />} />
      </Route>
    </Routes>
  );
}
